var contributors_accordion = (function( $ ) {

	var _init = function() {
		_setup_view_more_button();
		_setup_heading_link();
	};

	var _setup_view_more_button = function() {
		$( document ).on( 'click', '#view-more-accordion', function() {
			var $button = $( this );
			var $panel = $button.closest( '.panel' );
			var $collapse_element = $panel.find( '.panel-collapse' );

			var is_expanded = $collapse_element.attr( 'aria-expanded' ) === 'true';

			if ( ! is_expanded ) {
				$collapse_element.collapse( 'show' );
				$button.text( 'View Less' );
			} else {
				$collapse_element.collapse( 'hide' );
				$button.text( 'View More' );
			}
		} );
	};

	var _setup_heading_link = function() {
		$( document ).on( 'click', '.heading-link', function() {
			var $panel = $( this ).closest( '.panel' );
			var $collapse_element = $panel.find( '.panel-collapse' );
			var $button = $panel.find( '#view-more-accordion' );

			var is_expanded = $collapse_element.attr( 'aria-expanded' ) === 'true';

			if ( is_expanded ) {
				$button.text( 'View Less' );
			} else {
				$button.text( 'View More' );
			}
		} );
	};

	$( document ).ready( function() {
		_init();
	} );

	return {};

})( jQuery );
